import router from './router'
import { getToken } from './utils/auth'
import Store from "./store/index"
import glo_loading from './loading/index'  
import {routerLoading} from './loading/loadingConfig'  
const whiteList = [ '/watch', '/box', '/login', '/auth-redirect', '/open-app','/android','/bluetooth',"/downLoad"] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  routerLoading ? glo_loading.loadingShow() : '' //如果全局启用页面跳转则加载loading
   //权限判断
   let permissionsListHander = Store.getters.permissionsListHander;
   let permissionsFlag=permissionsListHander==="isAdmin" ? true : permissionsListHander.some(item=>item.path===to.path)
  // start progress bar
  //  console.log(to,from);
   Store.commit("changeFrom",from)
  // set page title
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title
   } else {
    document.title = 'Yhe Tech'
   }
  // determine whether the user has logged in
  const token = getToken()
  // console.log('token--------' + token)

  if (token != null && token != '') {
    // console.log('token不是空------' + to.path)
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
    } else {
      next()
      // if(permissionsFlag  || whiteList.indexOf(to.path) !== -1){
      //   next()
      // }else{
      //   next()

      // }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
    }
  }
 


})

router.afterEach(() => {

  routerLoading ? glo_loading.loadingHide() : ''//关闭loading层
  // finish progress bar
})
